import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export const currencyFormatter = (value) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="GBP"
  />
);

export const columns = [
  {
    name: "City",
    accessor: "location_html",
  },
  {
    name: "Rental Cost Per Sq. m.",
    accessor: "cost_per_sq_metre",
    formatter: currencyFormatter,
  },
];

export const rows = [
  {
    location_html: (
      <span>
        London
        <sup>3</sup>
      </span>
    ),
    cost_per_sq_metre: 24.71,
    monthly_rental_single: 963.69,
    yearly_income_single: 39876.84,
    monthly_rental_family: 1828.54,
    yearly_income_family: 75663.72,
  },
  {
    location_html: <span>Edinburgh</span>,
    cost_per_sq_metre: 12.85,
    monthly_rental_single: 501.15,
    yearly_income_single: 20737.2,
    monthly_rental_family: 950.9,
    yearly_income_family: 39347.64,
  },
  {
    location_html: <span>Bristol</span>,
    cost_per_sq_metre: 11.22,
    monthly_rental_single: 437.58,
    yearly_income_single: 18106.8,
    monthly_rental_family: 830.28,
    yearly_income_family: 34356.36,
  },
  {
    location_html: <span>Southampton</span>,
    cost_per_sq_metre: 10.68,
    monthly_rental_single: 416.52,
    yearly_income_single: 17235.36,
    monthly_rental_family: 790.32,
    yearly_income_family: 32702.88,
  },
  {
    location_html: <span>Manchester</span>,
    cost_per_sq_metre: 9.79,
    monthly_rental_single: 381.81,
    yearly_income_single: 15799.08,
    monthly_rental_family: 724.46,
    yearly_income_family: 29977.68,
  },
  {
    location_html: <span>Aberdeen</span>,
    cost_per_sq_metre: 9.61,
    monthly_rental_single: 374.79,
    yearly_income_single: 15508.56,
    monthly_rental_family: 711.14,
    yearly_income_family: 29426.52,
  },
  {
    location_html: <span>Cardiff</span>,
    cost_per_sq_metre: 9.24,
    monthly_rental_single: 360.36,
    yearly_income_single: 14911.44,
    monthly_rental_family: 683.76,
    yearly_income_family: 28293.48,
  },
  {
    location_html: <span>Leeds</span>,
    cost_per_sq_metre: 8.92,
    monthly_rental_single: 347.88,
    yearly_income_single: 14395.08,
    monthly_rental_family: 660.08,
    yearly_income_family: 27313.68,
  },
  {
    location_html: <span>Nottingham</span>,
    cost_per_sq_metre: 8.83,
    monthly_rental_single: 344.37,
    yearly_income_single: 14249.76,
    monthly_rental_family: 653.42,
    yearly_income_family: 27038.04,
  },
  {
    location_html: <span>Sheffield</span>,
    cost_per_sq_metre: 8.54,
    monthly_rental_single: 333.06,
    yearly_income_single: 13781.76,
    monthly_rental_family: 631.96,
    yearly_income_family: 26150.04,
  },
  {
    location_html: <span>Birmingham</span>,
    cost_per_sq_metre: 8.51,
    monthly_rental_single: 331.89,
    yearly_income_single: 13733.4,
    monthly_rental_family: 629.74,
    yearly_income_family: 26058.24,
  },
  {
    location_html: <span>Newcastle</span>,
    cost_per_sq_metre: 8.47,
    monthly_rental_single: 330.33,
    yearly_income_single: 13668.84,
    monthly_rental_family: 626.78,
    yearly_income_family: 25935.72,
  },
  {
    location_html: <span>Glasgow</span>,
    cost_per_sq_metre: 8.31,
    monthly_rental_single: 324.09,
    yearly_income_single: 13410.6,
    monthly_rental_family: 614.94,
    yearly_income_family: 25445.76,
  },
  {
    location_html: <span>Liverpool</span>,
    cost_per_sq_metre: 7.19,
    monthly_rental_single: 280.41,
    yearly_income_single: 11603.16,
    monthly_rental_family: 532.06,
    yearly_income_family: 22016.28,
  },
  {
    location_html: <span>Belfast</span>,
    cost_per_sq_metre: 6.29,
    monthly_rental_single: 245.31,
    yearly_income_single: 10150.8,
    monthly_rental_family: 465.46,
    yearly_income_family: 19260.36,
  },
];
